<style lang="less">
  .comm_upload_dialog {
    width: 640px;
  }
</style>
<template>
  <el-dialog  :visible.sync="is_show" :title="config.title" custom-class="comm_upload_dialog" @open="open" @close="handleClose">
    <div style="height: 480px">
      <file_upload v-if="fileConfig.userId" @handleUpload="handleUpload" :fileConfig="fileConfig"></file_upload>
    </div>
  </el-dialog>
</template>
<script>  
  // 只注册一次, 每打开一次弹出框就覆盖此函数 
  import file_upload from './file_upload_comp'
  export default {
    components: {
      file_upload
    },
    data() {
      return {
        randomCode:'rand_' + Math.random(),
        is_show: false,
        uploadUrl: null,
        fileConfig: {
          serverBasePath: '',
          sessionId: '',
          uploadFileMaxNum: '',
          uploadSingleFileSizeLimit: '',
          fileFormatAccept: {
            title: '',
            formats: '',
            mimeTypes: ''
          },
          userId: '',
        },
      }
    },
    props: {
      config: {
        type: Object,
        default () {
          return {
            title: '',
          }
        }
      },
    },
    methods: {
      handleClose( ){ 
        let vm =this;
        vm.fileConfig={}; 
      },
      handleUpload(data){
        let vm = this;
        if (data.code === vm.randomCode) {
            _.forEach(data.files, function (vv) {
              vv.fullPath =  window.filesystem_url  + '/file/data/' + vv.id;
            });
            vm.config.confirm(data.files)
            vm.is_show = false
          }
      },
      open() {
        let vm = this 
        vm.fileConfig = {
          serverBasePath: window.systemParameter.FILE_SYSTEM_URL,
          sessionId: vm.randomCode,
          uploadFileMaxNum: vm.config.uploadFileMaxNum,
          uploadSingleFileSizeLimit: vm.config.size ? vm.config.size : 20000 * 1024 * 1024,
          fileFormatAccept: {
            title: vm.config.title,
            extensions: vm.config.formats,
            mimeTypes: vm.config.mimeTypes
          },
          userId: window.appframe.$store.state.userInfo.id,
        }; 
      }
    },
    computed: {},
    watch: {},
    mounted() {},
  }
</script>


// WEBPACK FOOTER //
// src/commonplugin/fileUpload/comp.vue